module.exports = __webpack_public_path__ + "account/img/265.0ff8aa38.png";